import React, {useState} from 'react'
import './Home.css'

export default function Home() {
    const [name, setName] = useState('')
    const [room, setRoom] = useState('')

    const submit = (e) => {
        if(e.key === 'Enter') {
            console.log('Enter"')
            if(name && room) {
                if(name.length < 4) {
                    alert('name should be at least of 4 characters')
                    return;
                }
                if(room.length < 6) {
                    alert('room should be at least of 6 characters')
                    return;
                }
                window.location.href = `/chat/${name}/${room}`;
            } else {
                alert('both are required fields')
            }
        }
    }

    const join = (e) => {
        if(name && room) {
            if(name.length < 4) {
                alert('name should be at least 4 characters')
                return;
            }
            if(room.length < 8) {
                alert('room should be at least 8 characters')
                return;
            }
            window.location.href = `/chat/${name}/${room}`;
        } else {
            alert('both are required fields')
        }
    }

    return (
        <div className="container">

            <div className="container__box" align="center">

                <div className="container__box__heading">Join Chat</div>

                <input type="text" className="container__box__input" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />

                <input type="text" className="container__box__input" placeholder="Room" value={room} onChange={(e) => setRoom(e.target.value)} onKeyDown={submit} /> 

                <button className="container__box__button" onClick={join}>Join</button>

            </div>

        </div>
    )
}
